import { ImagePageImageMap } from "components/print/templates/ImagePageTemplateComponent";

export const PlaceholderImage: ImagePageImageMap = {
  1: {
    slotId: 1,
    fit: true,
    url: '/images/sponsor-grids/placed-placeholder.png'
  }
}